import { Box, useTheme } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Text } from "../Text/Text";
const IconContainer = styled.span `
  > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    left: ${(props) => (props.side === "left" ? 0 : null)};
    right: ${(props) => (props.side === "right" ? 0 : null)};
  }
`;
export const StatusText = (props) => {
    const theme = useTheme();
    return (React.createElement(Text, { variant: "body2", color: props.severity ? () => theme.palette[props.severity].main : "textPrimary", weight: 600, nowrap: true },
        React.createElement(Box, { component: "span", position: "relative", display: "inline" },
            props.iconLeft && React.createElement(IconContainer, { side: "left" }, props.iconLeft),
            React.createElement(Box, { component: "span", pl: props.iconLeft ? 3.5 : 0, pr: props.iconRight ? 3.5 : 0, style: {
                    display: "inline-block",
                    transform: "translateY(-1px)"
                } }, props.text),
            props.iconRight && React.createElement(IconContainer, { side: "right" }, props.iconRight))));
};
//# sourceMappingURL=StatusText.js.map